"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInstitutions = void 0;

var _api = require("../api");

var _useContextProvider = require("./useContextProvider");

var _react = require("react");

var _useRequest = require("./useRequest");

var useInstitutions = function useInstitutions() {
  var countryCode = (0, _useContextProvider.useContextSelector)(function (ctx) {
    return ctx.config.countryCode;
  });
  var state = (0, _useRequest.useRequest)();
  var request = state.request;
  (0, _react.useEffect)(function () {
    void request((0, _api.getInstitutions)((0, _api.getBankConnectApi)())(countryCode));
  }, [request, countryCode]);
  return state;
};

exports.useInstitutions = useInstitutions;